import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./pages/App";
import Atendimento from "./pages/Atendimento";
import Atendimentos from "./pages/Atendimentos";
import Layout from "./Layouts";
import Encerrado from "./pages/Encerrado";
import OpacityProvider from "./components/utils/opacity";
import Informacao from "./pages/Informacao";
import Pesquisa from "./pages/Avaliacao/Pesquisa";
import Agradecimento from "./pages/Agradecimento";
import Servico from "./pages/Avaliacao/Servico";
import Comentario from "./pages/Avaliacao/Comentario";
import Conclusao from "./pages/Avaliacao/Conclusao";
import Etapa1 from "./pages/Formulario/Etapa1";
import Conquistas from "./pages/Conquistas";
import VideoInstitucional from "./pages/VideoInstitucional";

const RouteSwitch = () => {
  return (
    <BrowserRouter basename={process.env.REACT_APP_ROOT_FOLDER}>
      <OpacityProvider>
        <Routes>
          {/* LAYOUT PARA HOME */}
          <Route
            path="/"
            element={
              <Layout variant="bg">
                <App />
              </Layout>
            }
          />

          {/* OUTRAS ROTAS */}
          <Route path="/atendimento" element={<Atendimentos />} />
          <Route path="/solicitacao" element={<Encerrado />} />
          <Route path="/atendimento/:id" element={<Atendimento />} />
          <Route path="/atendimento/:id/servicos" element={<Atendimento />} />
          <Route path="/atendimento/:id/info" element={<Informacao />} />
          <Route path="/pesquisa" element={<Pesquisa />} />
          <Route path="/servico" element={<Servico />} />
          <Route path="/comentario" element={<Comentario />} />
          <Route path="/conclusao" element={<Conclusao />} />
          <Route path="/etapa1" element={<Etapa1 />} />
          <Route path="/agradecimento" element={<Agradecimento />} />
          <Route path="/conquistas" element={<Conquistas />} />
          <Route path="/video-institucional" element={<VideoInstitucional />} />
        </Routes>
      </OpacityProvider>
    </BrowserRouter>
  );
};

export default RouteSwitch;
